
/**
 * @param val
 * @returns {boolean}
 */
export const isNumber = (val) =>
{
	return (val !== null && val !== '' && !isNaN(val) && typeof val !== 'object');
};
